export default "__VITE_ASSET__BjY1cdXI__"